import { combineReducers } from "@reduxjs/toolkit";
import authReducer from './features/authentication/authenticationSlice';
import dueDateExtensionNormalReducer from './features/billingAndCollection/dueDateExtensionNormalSlice';
import dueDateExtensionOverdueReducer from './features/billingAndCollection/dueDateExtensionOverdueSlice';
import installmentNormalReducer from './features/billingAndCollection/installmentsNormalSlice';
import installmentOverdueReducer from './features/billingAndCollection/installmentsOverdueSlice';
import setAsideNormalReducer from './features/billingAndCollection/setAsideNormalSlice';
import setAsideOverdueReducer from './features/billingAndCollection/setAsideOverdueSlice';
import billAdjustmentNormalReducer from './features/billingAndCollection/billAdjustmentNormalSlice';
import billAdjustmentOverdueReducer from './features/billingAndCollection/billAdjustmentOverdueSlice';
import partPaymentNormalReducer from './features/billingAndCollection/partPaymentNormalSlice';
import partPaymentOverdueReducer from './features/billingAndCollection/partPaymentOverdueSlice';
import mcrReducer from './features/billingAndCollection/mcrSlice';
import mcrNormalReducer from './features/billingAndCollection/mcrNormalSlice';
import mcrOverdueReducer from './features/billingAndCollection/mcrOverdueSlice';
import cp90DefectiveMetersReducer from "./features/dashboard/cp90DefectiveMetersSlice";
import overallPerformanceReducer from "./features/dashboard/overallPerformance";
import colNormalReducer from './features/generalServices/colNormalSlice';
import colOverdueReducer from './features/generalServices/colOverdueSlice';
import coaNormalReducer from './features/generalServices/coaNormalSlice';
import coaOverdueReducer from './features/generalServices/coaOverdueSlice';
import cotNormalReducer from './features/generalServices/cotNormalSlice';
import cotOverdueReducer from './features/generalServices/cotOverdueSlice';
import ncNormalReducer from './features/generalServices/ncNormalSlice';
import ncOverdueReducer from './features/generalServices/ncOverdueSlice';
import rcNormalReducer from './features/generalServices/rcNormalSlice';
import rcOverdueReducer from './features/generalServices/rcOverdueSlice';
import bcNormalReducer from './features/generalServices/bcNormalSlice';
import bcOverdueReducer from './features/generalServices/bcOverdueSlice';
import feedersStatusReducer from "./features/geoJson/feedersStatus";
import geoJsonReducer from "./features/geoJson/geoJson";
import divisionGeoJson from "./features/geoJson/divisionGeoJson"
import allocatedComplaintsReducer from "./features/powerComplaints/allocatedComplaintsSlice";
import workingComplaintsReducer from "./features/powerComplaints/workingComplaintsSlice";
import escalatedComplaintsReducer from "./features/powerComplaints/escalatedComplaintsSlice";
import mrcReducer from './features/powerComplaints/mrcSlice';
import onHoldComplaintsReducer from "./features/powerComplaints/onholdComplaintsSlice";
import pendingComplaintsReducer from "./features/powerComplaints/pendingComplaintsSlice";
import resolvedComplaintsReducer from "./features/powerComplaints/resolvedComplaintsSlice";
import statsReducer from './features/stats/statsSlice';
import colorSlice from "./features/powerComplaints/colorSlice";
import actionableNormalReducer from "./features/actionable/actionableNormalSlice";
import actionableOverdueReducer from "./features/actionable/actionableOverdueSlice";
import allComplaintsReducer from './features/powerComplaints/getComplaintSlice';
import allComplaintsForCFCReducer from './features/powerComplaints/complaintsForCFCs';
import officeCodeReducer from './features/officeCodeForName/officeCodeForName';
import provisionsReducer from './features/provisions/installmentProvisions';
import usersReducer from './features/accessManagement/usersSlice';
import  homeButtonSliceReducer  from "./features/powerComplaints/homeButtonSlice";
import authorizationSlice from './features/mdm/authorization';
import getSRDataForEmailSlice from './features/powerComplaints/getSRDataForEmailSlice'
import getCOASRDataForEmailSlice from './features/generalServices/getCOASRDataForEmailSlice'

export const rootReducer = combineReducers({
    auth: authReducer,
    stats: statsReducer,
    ncNormalPaginated: ncNormalReducer,
    ncOverduePaginated: ncOverdueReducer,
    rcNormalPaginated: rcNormalReducer,
    rcOverduePaginated: rcOverdueReducer,
    bcNormalPaginated: bcNormalReducer,
    bcOverduePaginated: bcOverdueReducer,
    coaNormalPaginated: coaNormalReducer,
    coaOverduePaginated: coaOverdueReducer,
    colNormalPaginated: colNormalReducer,
    colOverduePaginated: colOverdueReducer,
    cotNormalPaginated: cotNormalReducer,
    cotOverduePaginated: cotOverdueReducer,
    mcrPaginated: mcrReducer,
    mcrNormalPaginated: mcrNormalReducer,
    mcrOverduePaginated: mcrOverdueReducer,
    mrcPaginated: mrcReducer,
    installmentNormalPaginated: installmentNormalReducer,
    installmentOverduePaginated: installmentOverdueReducer,
    setAsideNormalPaginated: setAsideNormalReducer,
    setAsideOverduePaginated: setAsideOverdueReducer,
    dueDateExtensionNormalPaginated: dueDateExtensionNormalReducer,
    dueDateExtensionOverduePaginated: dueDateExtensionOverdueReducer,
    billAdjustmentNormalPaginated: billAdjustmentNormalReducer,
    billAdjustmentOverduePaginated: billAdjustmentOverdueReducer,
    partPaymentNormalPaginated: partPaymentNormalReducer,
    partPaymentOverduePaginated: partPaymentOverdueReducer,
    pendingComplaintsPaginated: pendingComplaintsReducer,
    allocatedComplaintsPaginated: allocatedComplaintsReducer,
    workingComplaintsPaginated: workingComplaintsReducer,
    onholdComplaintsPaginated: onHoldComplaintsReducer,
    escalatedComplaintsPaginated: escalatedComplaintsReducer,
    resolvedComplaintsPaginated: resolvedComplaintsReducer,
    geoJson: geoJsonReducer,
    divisionGeoJson: divisionGeoJson,
    feederStatus: feedersStatusReducer,
    cp90DefectiveMeters: cp90DefectiveMetersReducer,
    overallPerformance: overallPerformanceReducer,
    feederColor: colorSlice,
    actionableNormal: actionableNormalReducer,
    actionableOverdue: actionableOverdueReducer,
    allComplaints: allComplaintsReducer,
    allComplaintsForCFC: allComplaintsForCFCReducer,
    officeCode: officeCodeReducer,
    provisions: provisionsReducer,
    users: usersReducer,
    homeButton : homeButtonSliceReducer,
    authorization: authorizationSlice,
    getSRDataForEmail: getSRDataForEmailSlice,
    getCOASRDataForEmail: getCOASRDataForEmailSlice,

},)